import { render } from "./Photography.vue?vue&type=template&id=625ff610&scoped=true"
import script from "./Photography.vue?vue&type=script&lang=js"
export * from "./Photography.vue?vue&type=script&lang=js"

import "./Photography.vue?vue&type=style&index=0&id=625ff610&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625ff610"]])

export default __exports__